import PlayerNext from './src/player-next-combined';
export default PlayerNext;